module.exports = __webpack_public_path__ + "img/bang.d0d692c9.jpg";